import { useMutation } from '@tanstack/react-query'
import { trpcClient } from '~/lib/trpc.tsx'

export function useUpdateAssetFromUrl() {
  return useMutation({
    mutationFn: async ({ assetId, url }: { assetId: string; url: string }) => {
      const result = await trpcClient.property.updateFromUrl.mutate({
        webUrl: url,
        assetId,
      })

      if ('error' in result) {
        console.error(result.error)
        return null
      }

      return result
    },
    onError: (error) => {
      console.error('Error updating asset from scraped data', error)
      return error
    },
  })
}
